import TableTemplate from "../../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../../TableTemplate/common";
import { IDeltaHedgeExeDetailedStateTradeTableSearchParam } from "../../../../Interfaces/deltaHedgeExe";
import { getExeStatusTable } from "../../../../Requests/adjustment";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeDetailedStateTradeTableSearchParam;
}

const ExeStatus = ({ searchParams }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
          tableBoxClassName="!max-h-[300px] order-table"
        />
      )}
      getDataTable={getExeStatusTable}
      searchParameters={searchParams}
      refreshTableTime={5000}
    />
  );
};

export default ExeStatus;
